import { IonContent } from '@ionic/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import './LonelinessGraph.scss';

export const OnboardingReplikaLonelinessGraph: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Loneliness Graph',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  return (
    <OnboardingPage className="onboarding-loneliness-graph">
      <IonContent>
        <OnboardingTitle className="onboarding-loneliness-graph-title">
          Feeling lonely is okay. Even if you are in the relationship
        </OnboardingTitle>

        <div className="img-container">
          <img src="" alt="preferences_image" />
        </div>

        <div className="description">
          <UiTypography variant="title-medium" color="black">
            Odds of Premature Mortality
          </UiTypography>
          <UiTypography variant="label-small" color="neutral-black">
            Source: Holt-Lunstad J, Robles TF, Sbarra DA. <br />
            Advancing Social Connection as a
          </UiTypography>
        </div>
      </IonContent>

      <OnboardingFooter onContinue={wizard.nextStep} />
    </OnboardingPage>
  );
};
